import { Easing } from "react-native-reanimated";
import {
  DISSOLVE_CURVE,
  FOLD_CURVE,
  ICON_IN_CURVE,
  MORPH_CURVE,
  MOTION,
  MOVE_CURVE,
  SETTLE_CURVE,
} from "@libs/checkout-core";
import type { Curve } from "@libs/checkout-core";

/**
 * The checkout's motion in Reanimated: the same curves and durations the
 * web checkout draws with (`@libs/checkout-core` motion.ts and the pay
 * timeline), handed to Reanimated's bezier easing, so the native sheet
 * moves exactly as the web one does.
 */
export const bezier = (curve: Curve) =>
  Easing.bezier(curve[0], curve[1], curve[2], curve[3]);

export const EASE = {
  motion: bezier(MOTION.curve),
  fold: bezier(FOLD_CURVE),
  move: bezier(MOVE_CURVE),
  settle: bezier(SETTLE_CURVE),
  morph: bezier(MORPH_CURVE),
  iconIn: bezier(ICON_IN_CURVE),
  dissolve: bezier(DISSOLVE_CURVE),
} as const;

export {
  CHIP_MS,
  DISSOLVE_MS,
  FOLD_MS,
  ICON_IN_MS,
  MORPH_MS,
  MOTION,
} from "@libs/checkout-core";

/** The success screen's rows rising in after "You're going" (the web's
 *  lc-success-rise): each 520ms on the settle curve, 70ms apart. */
export const RISE_MS = 520;
export const RISE_STAGGER_MS = 70;
export const RISE_PX = 14;
